import { IconProps } from "../../app/models";

export const CopyIcon = ({
  size = 20,
  color,
  className,
  strokeWidth,
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clip-path="url(#clip0_730_3795)">
        <path
          d="M6.6665 13.3333V15.6667C6.6665 16.6001 6.6665 17.0668 6.84816 17.4233C7.00795 17.7369 7.26292 17.9919 7.57652 18.1517C7.93304 18.3333 8.39975 18.3333 9.33317 18.3333H15.6665C16.5999 18.3333 17.0666 18.3333 17.4232 18.1517C17.7368 17.9919 17.9917 17.7369 18.1515 17.4233C18.3332 17.0668 18.3332 16.6001 18.3332 15.6667V9.33334C18.3332 8.39992 18.3332 7.93321 18.1515 7.57669C17.9917 7.26308 17.7368 7.00812 17.4232 6.84833C17.0666 6.66667 16.5999 6.66667 15.6665 6.66667H13.3332M4.33317 13.3333H10.6665C11.5999 13.3333 12.0666 13.3333 12.4232 13.1517C12.7368 12.9919 12.9917 12.7369 13.1515 12.4233C13.3332 12.0668 13.3332 11.6001 13.3332 10.6667V4.33334C13.3332 3.39992 13.3332 2.93321 13.1515 2.57669C12.9917 2.26308 12.7368 2.00812 12.4232 1.84833C12.0666 1.66667 11.5999 1.66667 10.6665 1.66667H4.33317C3.39975 1.66667 2.93304 1.66667 2.57652 1.84833C2.26292 2.00812 2.00795 2.26308 1.84816 2.57669C1.6665 2.93321 1.6665 3.39992 1.6665 4.33334V10.6667C1.6665 11.6001 1.6665 12.0668 1.84816 12.4233C2.00795 12.7369 2.26292 12.9919 2.57652 13.1517C2.93304 13.3333 3.39975 13.3333 4.33317 13.3333Z"
          stroke={color || "#475467"}
          strokeWidth={strokeWidth || "1.66667"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_730_3795">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
